export enum Currency {
  AU = 'AUD',
  GB = 'GBP'
}

export enum TaxIncludeLocation {
  IM = 'IM',
  GB = 'GB'
}
